import { Component, Input, Output, EventEmitter, OnInit, TemplateRef, ChangeDetectionStrategy } from '@angular/core';

export interface BoxViewTab {
  label: string;
  content?: any;
}

@Component({
    selector: 'app-box-view',
    templateUrl: './box-view.component.html',
    styleUrls: ['./box-view.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BoxViewComponent implements OnInit {
  @Input() title?: string;
  @Input() link?: string;
  @Input() linkText?: string;
  @Input() noPadding: boolean = false;
  @Input() disableColPadding: boolean = false;
  @Input() tabs?: string[] | BoxViewTab[];
  @Input() rightBtn?: TemplateRef<any>;
  @Input() activeTabIndex: number = 0;
  @Output() tabSelected = new EventEmitter<number>();

  timestamp: number = 0;

  ngOnInit() {
    this.timestamp = new Date().getTime();
  }

  selectTab(index: number) {
    this.activeTabIndex = index;
    this.tabSelected.emit(index);
  }

  getTabLabel(tab: string | BoxViewTab): string {
    if (typeof tab === 'string') {
      return tab;
    }
    return tab.label;
  }

  hasTitle(): boolean {
    return !!this.title;
  }

  hasTabs(): boolean {
    return !!this.tabs && this.tabs.length > 0;
  }

  hasLink(): boolean {
    return !!this.link && !!this.linkText;
  }

  hasRightBtn(): boolean {
    return !!this.rightBtn;
  }

  getTabId(index: number): string {
    return `tab${this.timestamp}_${index}`;
  }
}